import React, { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import { colors } from "src/config/colors";
import { useRouter } from "next/router";
import {
  EnumMetrikActions,
  sendCustomYandexMetrik,
} from "src/config/analytics/sendCustomYandexMetrik";

const HeaderNavigation: React.FC = () => {
  const [value, setValue] = useState("categoryPageTitle");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const scrollToId = (
    id: string,
    setActiveItem?: React.Dispatch<React.SetStateAction<string>>
  ) => {
    if (id) {
      const itemId = document.getElementById(id);
      setActiveItem && setActiveItem(id);
      window.scrollTo({
        top:
          (itemId?.getBoundingClientRect().top || 0) + window.pageYOffset - 110,
        behavior: "smooth",
      });
    }
  };

  const router = useRouter();

  return (
    <Tabs
      sx={{
        ".Mui-selected": {
          color: "#3C56CB !important",
        },
        ".MuiTabs-indicator": {
          backgroundColor: "#3C56CB !important",
        },
        position: "sticky",
        top: { xs: 103, md: 124 },
        left: 0,
        zIndex: 1000,
        backgroundColor: colors.white,
        borderRadius: { xs: "0px", lg: "5px 5px 0px 0px" },
        borderColor: colors.darkYellow,
        boxShadow:
          "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
      }}
      value={value}
      onChange={handleChange}
      variant="scrollable"
    >
      <Tab
        value="categoryPageTitle"
        label="Основное"
        onClick={() => {
          if (router.query.product) {
            sendCustomYandexMetrik(
              EnumMetrikActions.clickMainNavigationBtnOnProductPage
            );
          }
          scrollToId("back-to-top-anchor");
        }}
      />
      <Tab
        value="analogs"
        label="Аналоги"
        onClick={() => {
          if (router.query.product) {
            sendCustomYandexMetrik(
              EnumMetrikActions.clickAnalogsNavigationBtnOnProductPage
            );
          }
          scrollToId("analogs");
        }}
      />
      <Tab
        value="instruction"
        label="Инструкция"
        onClick={() => {
          if (router.query.product) {
            sendCustomYandexMetrik(
              EnumMetrikActions.clickInstructionNavigationBtnOnProductPage
            );
          }
          scrollToId("instruction");
        }}
      />
    </Tabs>
  );
};

export default HeaderNavigation;
